
import { makeStyles } from '@material-ui/core/styles';
import { Box, Container } from "@mui/material";
import CardServices from '../departamentos/cardServices';
import HeaderSession from '../../utils/headerSession';
import { useEffect, useState } from "react";
import api from '../../services/api';
import RegisterAccess from '../../utils/registerAccess';
// import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  containerCardesService: {
    // minHeight: '50vh',
    padding: '1rem',
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
  }
}))

interface MenuState {
  analise: number;
  secretariaDirectorGeral: number;
  secretariaDirectorAdjAreaAdmin: number;
  secretariaDirectorAdjAreaTecnica: number;
  chefeDepartamento: number;
  directorAdjAreaAdmin: number;
  directorGeral: number;
  directorAdjAreaTecnica: number;
  finalizado: number;
  indeferido: number;
}


export default function MenuExpediente() {
  const classes = useStyles();
  // const user = useSelector(state => state.account.user);

  const [menu, setMenu] = useState<MenuState>({
    analise: 0,
    secretariaDirectorGeral: 0,
    secretariaDirectorAdjAreaAdmin: 0,
    secretariaDirectorAdjAreaTecnica: 0,
    chefeDepartamento: 0,
    directorAdjAreaAdmin: 0,
    directorGeral: 0,
    directorAdjAreaTecnica: 0,
    finalizado: 0,
    indeferido: 0,
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)


  useEffect(() => {
    api.get(`/menu/expediente`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <Container>
      <RegisterAccess page={'expediente'} />
      <HeaderSession title={'EXPEDIENTE'} />

      <Box className={classes.containerCardesService}>
        <CardServices load={loadMenu} count={menu.analise} icone={'/icones/expediente/entrada.svg'} nomeService={'Entradas'} link={'/admin/expediente/entradas'} />
        <CardServices load={loadMenu} count={menu.finalizado} icone={'/icones/expediente/saida.svg'} nomeService={'Saídas Utentes-Instituições'} link={'/admin/expediente/saidas'} />
        <CardServices load={loadMenu} count={menu.indeferido} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Indeferidos'} link={'/admin/expediente/indeferidos'} />
      </Box>

      {/* 
      <br />
      <hr style={{ border: '1px solid #85287e' }} />
      <Box className={classes.containerCardesService}>
        <CardServices load={loadMenu} count={menu.secretariaDirectorGeral} icone={'/icones/expediente/directorGeral.svg'} nomeService={'Secretaria Director Geral'} link={'/admin/expediente/encaminhado/director-geral'} />
        <CardServices load={loadMenu} count={menu.secretariaDirectorAdjAreaAdmin} icone={'/icones/expediente/secretariaDAAA.svg'} nomeService={'Secretaria Director Adj. Área Admin'} link={'/admin/expediente/encaminhado/'} />
        <CardServices load={loadMenu} count={menu.secretariaDirectorAdjAreaTecnica} icone={'/icones/expediente/secretariaDAAT.svg'} nomeService={'Secretaria Director Adj. Área Técnica'} link={'/admin/'} />
      </Box> */}

      <br />
      <hr style={{ border: '1px solid #85287e' }} />
      <Box className={classes.containerCardesService}>
        <CardServices load={loadMenu} count={menu.chefeDepartamento} icone={'/icones/expediente/entrada.svg'} nomeService={'Chefe de Departamento'} link={'/admin/expediente/encaminhado/chefe-departamento'} />
        <CardServices load={loadMenu} count={menu.directorAdjAreaAdmin} icone={'/icones/expediente/secretariaDAAA.svg'} nomeService={'Director Adj. Área Admin.'} link={'/admin/expediente/encaminhado/director-adj-area-admin'} />
        <CardServices load={loadMenu} count={menu.directorAdjAreaTecnica} icone={'/icones/expediente/secretariaDAAT.svg'} nomeService={'Director Adj. Área Técnica'} link={'/admin/expediente/encaminhado/director-adj-area-tecnica'} />
        <CardServices load={loadMenu} count={menu.directorGeral} icone={'/icones/expediente/directorGeral.svg'} nomeService={'Director Geral'} link={'/admin/expediente/encaminhado/director-geral'} />
      </Box>

    </Container>
  )
}





